
export default function WhyFree() {
  const blocks = [
    {
      icon: 'ri-store-2-line',
      title: 'Sponsor placements fund production',
      description: 'Local businesses sponsor the issue (clearly labeled as "Sponsored").'
    },
    {
      icon: 'ri-advertisement-line',
      title: 'We manage sponsor operations',
      description: 'We handle sponsorship selection, billing, placements, and disclosures.'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Facility reviews final proof',
      description: 'You review the final issue for brand alignment before distribution.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Facility pays $0',
      description: 'No facility budget required. Facility does not receive sponsorship revenue.'
    }
  ];

  return (
    <section id="how-its-funded" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">How it&apos;s funded</h2>
          <p className="text-base text-gray-600">
            Transparency matters. Here&apos;s how the sponsor-funded model works.
          </p>
        </div>

        {/* Flow Diagram */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-3 mb-6">
          {blocks.map((block, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-50 rounded-lg p-5 border border-gray-100 h-full flex flex-col items-center text-center hover:shadow-md hover:bg-white transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center mb-3 bg-gradient-to-br from-purple-50 to-red-50 rounded-full">
                  <i className={`${block.icon} text-2xl text-purple-600`}></i>
                </div>
                <h3 className="text-base font-semibold text-gray-900 mb-2 leading-tight">
                  {block.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {block.description}
                </p>
              </div>
              
              {/* Arrow between blocks (desktop only) */}
              {index < blocks.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -right-1.5 transform -translate-y-1/2 translate-x-1/2 z-10">
                  <i className="ri-arrow-right-line text-xl text-purple-400"></i>
                </div>
              )}
              
              {/* Down arrow (mobile/tablet only) */}
              {index < blocks.length - 1 && (
                <div className="flex lg:hidden justify-center my-3">
                  <i className="ri-arrow-down-line text-xl text-purple-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Trust line */}
        <div className="text-center mb-6">
          <p className="text-xs text-gray-500">
            Sponsored content is clearly labeled. Nothing is published without your review for brand alignment.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="#signup-form" 
            className="inline-block px-7 py-3.5 bg-gradient-to-r from-[#6B4EFF] to-[#FF4D7D] text-white font-semibold rounded-lg hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Request a pilot issue
          </a>
        </div>
      </div>
    </section>
  );
}
